import { Component, Input } from '@angular/core';

@Component({
  selector: 'un-footer-link',
  templateUrl: 'footer-link.component.html',
  styleUrls: ['footer-link.component.scss'],
  standalone: false,
})
export class FooterLinkComponent {
  @Input() public url?: string;
}
